/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{max-width:calc(500px - 48px);min-width:calc(500px - 48px);max-height:calc(18rem - 48px);min-height:calc(18rem - 48px);display:block;position:relative}.mat-dialog-actions[_ngcontent-%COMP%]{position:absolute;bottom:0;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-ms-flex-line-pack:center;align-content:center}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/services/dialogs/countdown/countdown.dialogcomponent.css.shim.ngstyle.js.pre-build-optimizer.js